// extracted by mini-css-extract-plugin
export default {"container":"r2t3R","headerCont":"M+qaQ","header":"lT70a","content":"GvzHH","controls":"_15W0V","signUpButton":"XLwGg","mobile":"OqLpu","desktop":"i808q"};